import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileCreditsAndRewardsSection from '/component/partial/profile/ProfileCreditsAndRewardsSection';
import {withTranslation} from '/provider/TranslationProvider';
import {
  rewardsBalanceById,
  rewardsCurrencyCodeById,
  wellnessCreditsBalanceById,
  wellnessCreditsCurrencyCodeById,
} from '/redux/selector/coach.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      wellnessCreditsBalance: wellnessCreditsBalanceById,
      wellnessCreditsCurrencyCode: wellnessCreditsCurrencyCodeById,
      rewardsBalance: rewardsBalanceById,
      rewardsCurrencyCode: rewardsCurrencyCodeById,
    }),
  ),
  withTranslation('screen.coachProfile.section.creditsAndRewards'),
)(ProfileCreditsAndRewardsSection);
